import { ActionIcon, Affix, Menu, Tooltip } from "@mantine/core";
import { IconLanguage } from "@tabler/icons-react";

import { DE, ES, FR, GB, GR, IT, NL } from "country-flag-icons/react/3x2";

import { useFooterOffset } from "@/hooks/use-footer-offset";
import { Language, useLanguageContext } from "@/hooks/use-language-context";
import { trackEvent } from "@/tracking";

const flagFor = (code: string, label: string) => {
  const props = {
    title: label,
    style: { width: 22, height: 16, borderRadius: 2 },
  };
  switch (code) {
    case "en":
      return <GB {...props} />;
    case "gr":
      return <GR {...props} />;
    case "fr":
      return <FR {...props} />;
    case "de":
      return <DE {...props} />;
    case "nl":
      return <NL {...props} />;
    case "es":
      return <ES {...props} />;
    case "it":
      return <IT {...props} />;
    default:
      return null;
  }
};

export function LanguageSelector() {
  const { language, languageOptions, setLanguage } = useLanguageContext();
  const bottom = useFooterOffset(20);

  const choose = (lang: Language) => {
    setLanguage(lang);
    trackEvent("Language Change", { language: lang.i18n, label: lang.label });
  };

  return (
    <Affix position={{ bottom, left: 20 }}>
      <Menu shadow="md" width={180} position="top-start" withArrow>
        <Menu.Target>
          <Tooltip
            label={`Language · ${language?.label ?? "English"}`}
            position="right"
            withArrow
          >
            <ActionIcon
              size={48}
              radius="xl"
              variant="filled"
              color="sea"
              aria-label="Choose language"
            >
              <IconLanguage size={24} />
            </ActionIcon>
          </Tooltip>
        </Menu.Target>
        <Menu.Dropdown>
          {languageOptions.map((lang) => (
            <Menu.Item
              key={lang.i18n}
              leftSection={flagFor(lang.i18n, lang.label)}
              onClick={() => choose(lang)}
              fw={language?.i18n === lang.i18n ? 600 : 400}
              c={language?.i18n === lang.i18n ? "sea.7" : undefined}
            >
              {lang.label}
            </Menu.Item>
          ))}
        </Menu.Dropdown>
      </Menu>
    </Affix>
  );
}

export default LanguageSelector;
